import * as React from "react";
import { useState, useEffect } from "react";
import 'font-awesome/css/font-awesome.min.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faL } from '@fortawesome/free-solid-svg-icons';
import '@fontsource/poppins';
import addressBook from "../../images/Acquisition/address_book_notebook_icon.svg";
import contactIcon from "../../images/Acquisition/contact_icon.svg";
import UserService from "../../services/UserService";
import ShowPaytmPaymentPage from "../ShowPaytmPaymentPage";
import ShowRazorPayPaymentPage from "../ShowRazorPayPaymentPage";
import OTPValidation from '../../subComponents/OTPValidation';
import SafeImage from '../../subComponents/SafeImage';
import CorporateMailUpdatePopup from '../../subComponents/CorporateMailUpdatePopup';
import CorporateDigitalPopup from '../../subComponents/CorporateDigitalPopup';
import { moengageCheckoutBtn_Clicked,moengageCheckoutPage_Viewed,moengage_Acq_CheckoutBackBtn_Clicked } from "../../common/moengageFunction";
import TermsPopup from "../../subComponents/TermsPopup";
import PageLoader from '../../subComponents/PageLoader';
import {registrationGetCityNameOrder, setUtmSource, getUtmParamsFromUrl, isValidUtmValue, getUtmUrl } from "../../common/commonFuntion";
import ReactGA from "react-ga4";
import { ToastContainer, toast } from 'react-toastify';
import {planNames} from '../../utils/utils.js';


const schemPublication = sessionStorage.getItem("stg_selectedPlan_Name") || null;
const PAYMENT_METHOD = process.env.REACT_APP_PAYMENT;
function Order({ orderData }) {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  const [paytmPageShow, setPaytmPageShow] = useState(false);
  const [gateway, setGateway] = useState(PAYMENT_METHOD);
  const [transToken, setTransToken] = useState("");
  const [mId, setMid] = useState("");
  const [checkout, setCheckout] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  const [termsErrmsg, setTermsErrmsg] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [mobileError, setMobileError] = useState();
  const [emailError, setEmailError] = useState();
  const [showPopupAlertState, setShowPopupAlertState] = useState(false);
  const [pincodeGiven, setPincodeGiven] = useState(false);
  const [utmSources, setUtmSources] = useState();
  const [utmCampaign, setUtmCampaign] = useState();
  const [showOTPModal, setShowOTPModal] = useState(false);
  const [showMailUpdateModal, setShowMailUpdateModal] = useState(false);
  const [otpValidated, setOtpValidated] = useState(false);
  const [otpValidatedEmail, setOtpValidatedEmail] = useState(false);
  const [currentMobile, setCurrentMobile] = useState(null);
  const [otpType, setOtpType] = useState(false);
  const [forInstitutional, setForInstitutional] = useState(false);
  const [schemPublication, setSchemPublication] = useState(sessionStorage.getItem("stg_selectedPlan_Name"));
  const [validDigitalOrder, setValidDigitalOrder] = useState(false);
  const [baseUrl, setBaseUrl] = useState('');

  // Add new state variables for cities
  const [allCities, setAllCities] = useState([]);
  const [filteredCities, setFilteredCities] = useState([]);
  const [citySearchTerm, setCitySearchTerm] = useState('');
  const [showCityDropdown, setShowCityDropdown] = useState(false);
  const [citiesLoading, setCitiesLoading] = useState(false);

  // Add new state for lead generation
  const [leadGenerationLoading, setLeadGenerationLoading] = useState(false);
  const [leadGenerationError, setLeadGenerationError] = useState('');

  // Add state to track if city is valid
  const [isCityValid, setIsCityValid] = useState(false);
  
  // Add state to track when user is selecting from dropdown
  const [isSelectingFromDropdown, setIsSelectingFromDropdown] = useState(false);

  const CORPORATE_STATUS = process.env.REACT_APP_CORPORATE_STATUS === 'true';

  const digitalPublication = ["LM", "HD", "LM;Mint", "Mint;LM", "BP;LM", "LM;BP"];

  const defultAlert = (msg) => toast.warn(msg, {
    position: "top-center"
  });

  const notFound = () => toast.warn("Some network issues, Please try again", { position: "top-center" });
  const emailUpdated = () => toast.success("Email has been updated", { position: "top-center" });
  const emailIdNotValid = () => toast.warn("Please enter a valid email", { position: "top-center" });
  const networkIssue = () => toast.warn("Some network issue, Please try again!", { position: "top-center" });
  const enterEmail = () => toast.warn("Please enter your email Id", { position: "top-center" });
  

  // Function to fetch all cities - Updated for correct response structure
  const fetchAllCities = async () => {
    setCitiesLoading(true);
    try {
      const salesOrg = sessionStorage.getItem("stg_location_code") || "";
      const response = await UserService.getLocalities(salesOrg, "");
      
      if (response && response.data && response.data.success) {
        const localities = response.data.response || []; // Changed from localities to response
        
        // Remove duplicates based on city name
        const uniqueCities = localities.reduce((acc, current) => {
          const existingCity = acc.find(city => 
            city.city.toLowerCase() === current.city.toLowerCase()
          );
          if (!existingCity) {
            acc.push({
              id: current.id,
              city: current.city,
              name: current.name,
              pincode: current.pincode,
              state: current.state
            });
          }
          return acc;
        }, []);
        
        // Sort cities alphabetically
        uniqueCities.sort((a, b) => a.city.localeCompare(b.city));
        
        setAllCities(uniqueCities);
        setFilteredCities(uniqueCities);
      } else {
        console.error("Failed to fetch cities:", response?.data?.message);
        setAllCities([]);
        setFilteredCities([]);
      }
    } catch (error) {
      console.error("Error fetching cities:", error);
      setAllCities([]);
      setFilteredCities([]);
    } finally {
      setCitiesLoading(false);
    }
  };

  // Function to handle city search
  const handleCitySearch = (searchTerm) => {
    setCitySearchTerm(searchTerm);
    
    if (searchTerm.trim() === '') {
      setFilteredCities(allCities);
      setShowCityDropdown(allCities.length > 0);
    } else {
      const filtered = allCities.filter(city =>
        city.city.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredCities(filtered);
      setShowCityDropdown(filtered.length > 0);
    }
  };

  // Function to select a city
  const selectCity = (selectedCity) => {
    setData(prevState => ({
      ...prevState,
      city: selectedCity.city
    }));
    setCitySearchTerm(selectedCity.city);
    setShowCityDropdown(false);
    setIsCityValid(true); // Mark as valid when selected from dropdown
    
    // Clear any existing city errors immediately
    setFormErrors(prevErrors => {
      const newErrors = { ...prevErrors };
      delete newErrors.city;
      return newErrors;
    });
    
    // Save to session storage
    sessionStorage.setItem("stg_city", selectedCity.city);
    sessionStorage.setItem("stg_locality_id", selectedCity.id);
    
    // Auto-save if lead exists
    if (sessionStorage.getItem("lead_id")) {
      saveFieldDataonBlurEvent();
    }
  };

  // Function to call addNewLeadGenerate with retry logic - Updated for automatic background retry
  const addNewLeadGenerateWithRetry = async (mobile, schemeId, utmSource, forInstitutional, utmCampaign, giftId, maxRetries = 3) => {
    setLeadGenerationLoading(true);
    setLeadGenerationError('');
    
    for (let attempt = 1; attempt <= maxRetries; attempt++) {
      try {        
        const response = await UserService.addNewLeadGenerate(
          mobile,
          schemeId,
          utmSource,
          forInstitutional,
          utmCampaign,
          giftId
        );
        
        // Check if response is successful AND lead_id exists
        if (response && response.data && response.data.success && response.data.lead_id) {
          const leadId = response.data.lead_id;
          sessionStorage.setItem("lead_id", leadId);
          setLeadGenerationLoading(false);
          setLeadGenerationError(''); // Clear any previous errors
          return { success: true, leadId };
        } else {
          console.warn(`Lead generation failed on attempt ${attempt}:`, {
            success: response?.data?.success,
            leadId: response?.data?.lead_id,
            message: response?.data?.message
          });
          
          // If it's the last attempt, don't retry
          if (attempt === maxRetries) {
            break;
          }
          
          // Wait before retrying (exponential backoff)
          await new Promise(resolve => setTimeout(resolve, 1000 * attempt));
        }
      } catch (error) {
        console.error(`Error on attempt ${attempt}:`, error);
        
        // If it's the last attempt, don't retry
        if (attempt === maxRetries) {
          break;
        }
        
        // Wait before retrying (exponential backoff)
        await new Promise(resolve => setTimeout(resolve, 1000 * attempt));
      }
    }
    
    // If we reach here, all attempts failed
    const errorMessage = "Something went wrong while creating your order. Please try again.";
    setLeadGenerationError(errorMessage);
    setLeadGenerationLoading(false);
    
    // Reset mobile number field and show error
    setMobileError("Failed to create lead. Please enter your mobile number again.");
    setData(prevState => ({
      ...prevState,
      mobile_no: ""
    }));
    setOtpValidated(false);
    
    // Remove mobile from session storage
    sessionStorage.removeItem("stg_mobile_number");
    
    defultAlert(errorMessage);
    return { success: false, error: errorMessage };
  };

  const createNewLead = async () => {
    try {
      const schemeId = sessionStorage.getItem("stg_scheme_id");
      const storedMobile = sessionStorage.getItem("stg_mobile_number");
            
      if (!storedMobile || storedMobile !== currentMobile || data.mobile_no) {
          sessionStorage.setItem("stg_mobile_number", data.mobile_no);

          // Use the retry function - no need to handle result since it handles errors internally
          await addNewLeadGenerateWithRetry(
            data.mobile_no, 
            schemeId, 
            utmSources, 
            forInstitutional, 
            utmCampaign, 
            data.gift_id
          );
      } else {
        setMobileError("Mobile number is required!");
      }
    } catch (error) {
      setMobileError(error);
      console.error("Error in createNewLead:", error);
    }
  };

  useEffect(() => {
    setGateway(PAYMENT_METHOD);
    const updatedData = { ...data };
    let UtmData = getUtmParamsFromUrl();
    const utmSourceParam = UtmData?.utmSource;
    const utmCampaignParam = UtmData?.utmCampaign;
    const validSources = isValidUtmValue(utmSourceParam, "REACT_APP_VALID_SOURCES");
    const validCampaign = isValidUtmValue(utmCampaignParam, "REACT_APP_UTM_CAMPAIGN");
    
    if (validSources) {
      setUtmSources(utmSourceParam.toUpperCase());
      if (validCampaign) {
        setUtmCampaign(utmCampaignParam);
      }
    }

    // Remove automatic city assignment - start with empty city
    // updatedData.city = registrationGetCityNameOrder(orderData?.cityName ?? sessionStorage.getItem("stg_city"));
    updatedData.city = ""; // Start with empty city
    updatedData.pincode = orderData?.cityPincode ?? sessionStorage.getItem("moe_acq_Pincode");
    updatedData.gift_id = orderData?.gift?.id;
    updatedData.gift_name = orderData?.gift?.name;
    updatedData.gift_image = Array.isArray(orderData?.gift?.images) && orderData.gift.images.length > 0
    ? orderData.gift.images[0]
    : '';
    updatedData.mobile_no = data.mobile_no || sessionStorage.getItem("stg_mobile_number") || "";
    
    // Set initial city search term to empty
    setCitySearchTerm('');
    
    const otpValidatedCheckVar = sessionStorage.getItem("stg_otpValidated") === "true";
    const otpValidatedCheck = otpValidated || otpValidatedCheckVar || false;
    const schemPublicationData = schemPublication || sessionStorage.getItem("stg_selectedPlan_Name") || null;
    const otpEmailValidatedCheckVar = sessionStorage.getItem("stg_otpEmailValidated") === "true";
    const otpEmailValidatedCheck = otpValidatedEmail || otpEmailValidatedCheckVar || false;
    const forInstitutionalVar = utmSourceParam?.toUpperCase() === "CORPORATE" && CORPORATE_STATUS;
    const utmUrl = getUtmUrl('msg');
    
    setBaseUrl(utmUrl);
    setData(updatedData);
    setOtpValidated(otpValidatedCheck);
    setForInstitutional(forInstitutionalVar);
    setSchemPublication(schemPublicationData);
    
    // Fetch all cities on component load
    fetchAllCities();
    
    ReactGA.ga('send', 'pageview', '/AcquisitionShippingAddress');

    // Remove pincodeGiven logic - always allow pincode input
    // if (orderData?.cityPincode !== "") {
    //     setPincodeGiven(true);
    // }

    if(forInstitutionalVar){
      updatedData.email = data.email || sessionStorage.getItem("stg_verifiedEmail") || "";
      setOtpValidatedEmail(otpEmailValidatedCheck);
      if (!updatedData.email && !otpEmailValidatedCheck) {
        window.location = `/`;
      }
    }
    
    // Updated lead generation with retry logic
    if (updatedData.mobile_no && otpValidatedCheck) {
        addNewLeadGenerateWithRetry(
            updatedData.mobile_no,
            sessionStorage.getItem("stg_scheme_id"),
            utmSourceParam,
            forInstitutionalVar,
            utmCampaignParam,
            updatedData.gift_id
        );
    } else if(updatedData.mobile_no){
        checkMobileExist(updatedData.mobile_no, otpEmailValidatedCheck, forInstitutionalVar, utmUrl);
    }
  }, []);

  const validOrderOnDigitalFn = async (schemPublicationData, mobile, email) => {

    if (digitalPublication.includes(schemPublicationData)) {
      try {
        if(email && mobile){
          const response = await UserService.validOrderOnDigital(email, mobile);
        
          if (response?.data?.success) {
              setValidDigitalOrder(false); // Valid order, no action needed
              return true;
          } else if (response?.data?.message === "Subscription already exists!") {
            setValidDigitalOrder(true);
            // setShowMailUpdateModal(true);
            return false;
          }else {
               // Invalid order, show modal
              // defultAlert(`${response?.message || "Something went wrong. Please try again."}`);
              setValidDigitalOrder(false);
              return true;
          }
        }else{
          setValidDigitalOrder(false); 
          return true;
        }
      } catch (err) {
          console.error("Error in validating digital order:", err);
          setValidDigitalOrder(false); 
          return true;
      }
    }else{
      setValidDigitalOrder(false); 
      return true;
    }

  };

  const validateOtp = (otp) => {
    return new Promise((resolve) => {
        // const otpSource = otpType ? data.email : data.mobile_no;
        const otpSource = data.mobile_no;
        UserService.verifiyOtpFresh(otp, otpSource, "SSP")
            .then((response) => {
                if (response && response.data) {
                    resolve({ success: true });
                } else if (!response.success) {
                    resolve({
                        success: false,
                        message: `${response.message || "Invalid OTP. Please try again."}`,
                    });
                } else {
                    resolve({
                        success: false,
                        message: "Something went wrong. Please try again.",
                    });
                }
            })
            .catch((err) => {
                console.error("Error in validateOtp:", err);
                if (err && err.response && err.response.data) {
                    if (err.response.status === 429) {
                        resolve({
                            success: false,
                            message: "You have entered incorrect OTP multiple times. Please try after 30 minutes.",
                        });
                    } else {
                        resolve({
                            success: false,
                            message: `${err.response.data.message || "Something went wrong!"}`,
                        });
                    }
                } else {
                    resolve({
                        success: false,
                        message: "Something went wrong!",
                    });
                }
            });
    });
  };


  // Duplicate createNewLead removed to fix redeclaration error.

  const sendOtp = async () => {
    
    let result = false;
    result = await checkMobileExist(data.mobile_no, otpValidatedEmail, forInstitutional, baseUrl);
    return { success: result };
  };


  // Update the handleChange function to handle city input
  const handleChange = (e) => {
    e.persist();
    let { name, value } = e.target;
    const re = /^[a-zA-Z\s]*$/g;
    
    if (name === 'first_name' && (value === "" || re.test(value))) {
      setData((prevState) => ({ ...prevState, [e.target.name]: e.target.value }));
    } else if (name === 'pincode') {
      let pincodevalue = e.target.value.replace(/\D/g, "");
      setData((prevState) => ({ ...prevState, [e.target.name]: pincodevalue }));
    } else if (name === 'mobile_no') {
      setOtpValidated(false);
      setOtpType(false);
      let mobileVal = e.target.value.replace(/\D/g, "");
      setData((prevState) => ({ ...prevState, [e.target.name]: mobileVal }));
    } else if (name === 'city') {
      handleCitySearch(value);
      setData((prevState) => ({ ...prevState, [name]: value }));
      
      // Check if typed city matches any valid city
      const exactMatch = allCities.find(city => 
        city.city.toLowerCase() === value.toLowerCase()
      );
      setIsCityValid(!!exactMatch);
      
      if (value.trim() !== '') {
        setShowCityDropdown(true);
      }
    } else if (name !== 'first_name') {
      setData((prevState) => ({ ...prevState, [name]: value }));
    }
  };

  const updateTermsCheckbox = (event) => {
    if (event.target.checked) {
      data.terms = true;
      setData({ ...data });
    } else {
      data.terms = false;
      setData({ ...data });
    }
    setIsChecked((current) => !current);
  };

  let genrateNumberUUId = () => {
    const length = 15;
    const chars =
      "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
    var result = "";
    for (var i = length; i > 0; --i)
      result += chars[Math.round(Math.random() * (chars.length - 1))];

    sessionStorage.setItem("linkId", result);
    return result;
  };

  let cleanObj =(obj) => {
    for (var propName in obj) {
      if (obj[propName] === null || obj[propName] === undefined || obj[propName]=='') {
        delete obj[propName];
      }
    }
    return obj
  }


  let saveFieldDataonBlurEvent = () =>{
    let savedataObj  = {
      "order_id"      : sessionStorage.getItem("lead_id"),
      "email"         : data.email,
      "customer_name" : data.first_name,
      "flat_no"       : data.flat,
      "block_or_street"  : data.block,
      "locality_non_master"  : data.locality,
      "city"          : data.city,
      "pin_code"      : data.pincode,
      "initiator"     : "acquisition_journey_info_update"} ; 

     let finalObj = cleanObj(savedataObj);

    UserService.addDeliveryAdress(finalObj).then((response) =>{
              
    })
  }

  const renderMygateData =(mygateData)=>{
    data.email = (mygateData.email) ? mygateData.email : '';
    data.first_name = ((mygateData.firstName) ? mygateData.firstName + ' ' : '') + ((mygateData.lastName) ? mygateData.lastName : '');
    data.flat = (mygateData.flatNo) ? mygateData.flatNo : '';
    data.block = (mygateData.floor) ? mygateData.floor : '';
    data.locality = (mygateData.otherSociety) ? mygateData.otherSociety : '';
    data.city = (mygateData.city) ? mygateData.city : '';
    data.pincode = (mygateData.pinCode) ? mygateData.pinCode : '';
    data.terms = true;
    setIsChecked(true);
    setData({ ...data });

  }

  const updateEmailAddress = () => {
    return new Promise((resolve) => {
      const email = data.email;
      if (email && data.mobile_no) {
          UserService.updateEmail(email, data.mobile_no)
          .then((response) => {
              if (response && response.data) {
                  resolve({ success: true });
              } else if (!response.success) {
                  resolve({
                      success: false,
                      message: `${response.message || "Something went wrong. Please try again."}`,
                  });
              } else {
                  resolve({
                      success: false,
                      message: "Something went wrong. Please try again.",
                  });
              }
          })
          .catch((err) => {
              console.error("Error in updateEmailAddress-on fresh:", err);
              if (err && err.response && err.response.data) {
                  if (err.response.status === 429) {
                      resolve({
                          success: false,
                          message: "You hit multiple request at a times. Please try after 30 minutes.",
                      });
                  } else {
                      resolve({
                          success: false,
                          message: `${err.response.data.message || "Something went wrong!"}`,
                      });
                  }
              } else {
                  resolve({
                      success: false,
                      message: "Something went wrong!",
                  });
              }
          });
      }else{
        enterEmail();
      }
    });
  };

  const checkMobileExistWithEvent = async (e) => {
      e.preventDefault(); 
      setOtpType(false);
      setFormErrors({});
      setMobileError("");
      const enterMobile = e.target.value.trim();
      if (!enterMobile) {
          setFormErrors({ mobile_no: "This field is required." });
          return false;
      }

      if (enterMobile.length < 10) {
          setFormErrors({ mobile_no: "Mobile No. should not be less than 10 digits." });
          return false;
      }

      if(otpValidated){
        return;
      }
      await checkMobileExist(enterMobile, otpValidatedEmail, forInstitutional, baseUrl);
  };

  const checkMobileExist = async (enterMobile, otpValidatedEmailVar, forInstitutionalVar, baseUrlState) => {
    const trimmedMobile = enterMobile.trim();
    setCurrentMobile(trimmedMobile);
    setLoading(true);
  
    try {
      const otpResponse = await UserService.generateFreshMobOtp(trimmedMobile, "SSP");
      if (otpResponse?.success) {
        setShowOTPModal(true);
        setFormErrors({});
        setMobileError("");
        return true;
      }
  
      else if (!otpResponse?.success && otpResponse?.message === "Mobile number does Not exists") {
        if(otpValidatedEmailVar && forInstitutionalVar) {
          // alert("ok");
          // setValidDigitalOrder(false);
          setShowMailUpdateModal(true);
        }
        setMobileError(
          <>
            You are already an existing reader with us. Please{' '}
            <a href={baseUrlState}>click here</a> to log in to your account.
          </>
        );
        return false;
      }
  
      else if (!otpResponse?.success && otpResponse?.message) {
        setMobileError(otpResponse.message);
        return false;
      }
      else{
        setMobileError("Something went wrong!");
        return false;
      }

    } catch (error) {
      console.error("Error in checkMobileExist:", error);
      setMobileError(error?.message || "An unexpected error occurred.");
      return false;
    } finally {
      setLoading(false);
    }
  };
  

  const saveEmailWithEvent = async (e) => {
      e.preventDefault();
      setOtpType(true);
      setFormErrors({});
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
      let emailId = e.target.value;
      if (!emailId) {
        setFormErrors({email : "This field is required."});
        return false;
      } else if (emailId!= "" && !emailRegex.test(emailId)) {
        setFormErrors({email :"This is not a valid email format."});
        return false;
      }else{
        if (sessionStorage.getItem("lead_id")) {     
            saveFieldDataonBlurEvent();
        }
      }

      // if(otpValidatedEmail){
      //   return;
      // }
      // alert(e.target.value);
      // await saveEmail(e.target.value); 
  };

  const saveEmail = async (emailId) =>{
    setLoading(true);
    try {
      const otpResponse = await UserService.generateFreshEamilOtp(emailId, "SSP");

      if (otpResponse?.success) {
          setShowOTPModal(true);
          setFormErrors({});
          setEmailError("");
          setLoading(false);
          return true;

      }else if(otpResponse?.message){
        setEmailError(otpResponse.message);
        setLoading(false);
        return false;
      }
      else{
        setEmailError(`${otpResponse.message || "Something went wrong"}`);
        setLoading(false);
        return false;
      }

    } catch (error) {
      console.error("Error in checkMobileExistWithEvent:", error);
      setMobileError(error);
      setLoading(false);
      return false;
    }

  }

  const saveName = (e) =>{
    e.preventDefault();
    setFormErrors({});
    let username = e.target.value;
    if (!username) {
      setFormErrors({first_name : "This field is required."});
    }else{
      if(sessionStorage.getItem("lead_id")!=undefined){       
        saveFieldDataonBlurEvent();
      }
    }
  }

  const saveFlatNo = (e) =>{
    e.preventDefault();
    setFormErrors({});
    let flat_no = e.target.value;
    if (!flat_no) {
      setFormErrors({flat : "This field is required."});
    }else if (flat_no!=undefined && flat_no.length >10 ) {
      setFormErrors({flat : "Flat no should not greater then 10 character."});
    }else{    
      if(sessionStorage.getItem("lead_id")!=undefined){       
        saveFieldDataonBlurEvent();
      }
    }
  }

  const saveBlockStreet = (e) =>{
    e.preventDefault();
    setFormErrors({});
    let blockStreet = e.target.value;
    if (!blockStreet) {
      setFormErrors({block : "This field is required."});
    }else {
      if(sessionStorage.getItem("lead_id")!=undefined){        
        saveFieldDataonBlurEvent();
      }
    }
  }

  const savelocality = (e) =>{
    e.preventDefault();
    setFormErrors({});
    let locality = e.target.value;
    if (!locality) {
      setFormErrors({locality : "This field is required."});
    }else{
      if(sessionStorage.getItem("lead_id")!=undefined){        
        saveFieldDataonBlurEvent();
     }
    }
  }

  const savePincode = (e) =>{
    e.preventDefault();
    setFormErrors({});
    let pincodeval = e.target.value;
    if (!pincodeval) {
      setFormErrors({pincode : "This field is required."});
    }else if (pincodeval != "" && pincodeval.length < 6) {
      setFormErrors({pincode : "Pincode must be 6 digit."});
    }else{ 
      if(sessionStorage.getItem("lead_id")!=undefined){       
        saveFieldDataonBlurEvent();
      }
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormErrors({});
    let errorObj =  validate(data);
      
    if (Object.values(errorObj).length > 0) {
      setFormErrors(errorObj);
    } else {
      // if(data.mobile_no && !otpValidated){
      //   await checkMobileExist(data.mobile_no);
      // }
      setCheckout(true);
      sessionStorage.removeItem("flat_no");
      sessionStorage.removeItem("block_or_street");
      sessionStorage.removeItem("locality");
      sessionStorage.removeItem("city");
      sessionStorage.removeItem("pin_code");
      sessionStorage.removeItem("email");
      sessionStorage.removeItem("customer_name");
      sessionStorage.removeItem("stg_mobile_number");

      sessionStorage.setItem("flat_no", data.flat);
      sessionStorage.setItem("block_or_street", data.block);
      sessionStorage.setItem("locality", data.locality);
      sessionStorage.setItem("city", data.city);
      sessionStorage.setItem("state", data.city);
      sessionStorage.setItem("pin_code", data.pincode);
      sessionStorage.setItem("email", data.email);
      sessionStorage.setItem("customer_name", data.first_name);
      sessionStorage.setItem("stg_mobile_number", data.mobile_no);
      sessionStorage.setItem("stg_emailAdress_Checkout_updated", data.email);

      let RandomUuid = genrateNumberUUId();

      moengageCheckoutBtn_Clicked();

      if(sessionStorage.getItem("lead_id")!=undefined){     
        saveFieldDataonBlurEvent();
      }


      // Payment Transaction API //
      UserService.paymentTransaction(
        RandomUuid,
        orderData?.planPrice ?? sessionStorage.getItem("moe_acq_selected_planPrice"),
        data.mobile_no,
        orderData?.planId ?? sessionStorage.getItem("stg_scheme_id"),
        "fresh_" + data.mobile_no,
        gateway,
        data.email,
        "",
        sessionStorage.getItem("lead_id")
      )
        .then((response) => {
          if (response.success) {
            setTransToken(response.txnToken);
            setMid(response.mid);
            // sessionStorage.setItem("mId", response.mid);
            sessionStorage.setItem("stg_leadId", response.lead_id);
            sessionStorage.removeItem("stg_mobile_number");
            sessionStorage.removeItem("stg_otpValidated");
            setPaytmPageShow(true);
            setCheckout(false);
          } else {
            setCheckout(false);
            defultAlert(`Payment Failed!`)
            //this.setState({ loading: false });
          }
        })
        .catch((err) => {
          defultAlert(`Payment Failed! ${err}`)
          //this.setState({ loading: false });
          sessionStorage.removeItem("stg_mobile_number");
          setCheckout(false);
        });
    }
  };

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;

  const validate =  (values) => {
    const errors = {};
    if (!values.mobile_no) {
      errors.mobile_no = "This field is required.";
    }else if(values.mobile_no!='' && values.mobile_no.length < 10){
      errors.mobile_no = "Mobile No. should not less then 10 digit";
    
    }else if(!otpValidated && !mobileError){
      errors.mobile_no = "Mobile number verification is incomplete. Please complete the OTP process.";
      defultAlert("Mobile number verification is incomplete. Please complete the OTP process.");
    }
    if (!values.email) {
      errors.email = "This field is required.";
    } else if (values.email != "" && !emailRegex.test(values.email)) {
      errors.email = "This is not a valid email format.";
    }

    if (!values.first_name) {
      errors.first_name = "This field is required.";
    }
    if (!values.flat) {
      errors.flat = "This field is required.";
    }
    if (values.flat!=undefined && values.flat.length >10 ) {
      errors.flat = "Flat no should not greater then 10 character.";
    }
    if (!values.block) {
      errors.block = "This field is required.";
    }
    if (values.block!=undefined && values.block.length >50) {
      errors.block = "Block/street no should not greater then 50 character.";
    }
    if (!values.locality) {
      errors.locality = "This field is required.";
    }
    if (values.locality!=undefined && values.locality.length >50 ){
      errors.locality = "Locality should not greater then 50 character.";
    }
    if (!values.city) {
      errors.city = "This field is required.";
    } else if (values.city) {
      // Always check if the entered city matches any valid city, regardless of isCityValid state
      const isValidCity = allCities.some(city => 
        city.city.toLowerCase() === values.city.toLowerCase()
      );
      if (!isValidCity) {
        errors.city = "Please select a city from the dropdown options.";
      }
    }
    if (!values.pincode) {
      errors.pincode = "This field is required.";
    }
    if (values.pincode != "" && values.pincode.length < 6) {
      errors.pincode = "Pincode must be 6 digit.";
    }

    if (!values.terms) {
      errors.termsmsg = "Please accept terms and conditions";
      setTermsErrmsg(true);
    } else {
      setTermsErrmsg(false);
    }
    return errors;
  };

    // Add this function after the selectCity function
  const saveCityOnBlur = (e) => {
    e.preventDefault();
    const cityValue = e.target.value.trim();
    
    // Add a small delay to allow click events on dropdown options to process first
    setTimeout(() => {
      setFormErrors(prevErrors => {
        const newErrors = { ...prevErrors };
        delete newErrors.city;
        return newErrors;
      });
      
      if (!cityValue) {
        setFormErrors(prevErrors => ({
          ...prevErrors,
          city: "This field is required."
        }));
        return;
      }
      
      // Check if the entered city matches any valid city
      const exactMatch = allCities.find(city => 
        city.city.toLowerCase() === cityValue.toLowerCase()
      );
      
      if (!exactMatch) {
        // Only show error if user is not actively selecting from dropdown
        if (!isSelectingFromDropdown && !showCityDropdown) {
          setFormErrors(prevErrors => ({
            ...prevErrors,
            city: "Please select a city from the dropdown options."
          }));
          setIsCityValid(false);
        }
        return;
      }
      
      // If valid city, auto-select it
      if (exactMatch && !isCityValid) {
        selectCity(exactMatch);
      }
      
      if (sessionStorage.getItem("lead_id")) {
        saveFieldDataonBlurEvent();
      }
    }, 150); // Small delay to allow click events to process
  };

  const redirectToHome = () => {
    if (sessionStorage.getItem("createNewAccountActive") === "ON") {
      moengage_Acq_CheckoutBackBtn_Clicked();      
      sessionStorage.removeItem("stg_mobile_number");
      sessionStorage.removeItem("stg_otpValidated");
      if(forInstitutional){
        let utmParams = setUtmSource("utm_source");
        const finalUrl = utmParams ? `/?msg=newCustomer&utm_source=Corporate&${utmParams}` : `/?msg=newCustomer&utm_source=Corporate`;
        window.location.href = finalUrl;
      }else{
        window.location = getUtmUrl();
      }
    } else {
      sessionStorage.removeItem("stg_otpValidated");
      window.location = getUtmUrl('msg');
    }
  };

  const showTermsPopup = () => {
    setShowPopupAlertState(true);
  };

  const closeTermsPopup = () => {
    setShowPopupAlertState(false);
  };

  const onDismissRazorpay =()=> {
    setPaytmPageShow(false);
    setCheckout(false);
   }

   // Add useEffect to handle clicking outside dropdown
   useEffect(() => {
    const handleClickOutside = (event) => {
      if (showCityDropdown && !event.target.closest('.city-dropdown-container')) {
        setShowCityDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showCityDropdown]);

  // useEffect to ensure city validation is synchronized when city data changes
  useEffect(() => {
    if (data.city && allCities.length > 0) {
      const isValidCity = allCities.some(city => 
        city.city.toLowerCase() === data.city.toLowerCase()
      );
      setIsCityValid(isValidCity);
      
      // If city is valid, clear any existing errors
      if (isValidCity) {
        setFormErrors(prevErrors => {
          const newErrors = { ...prevErrors };
          delete newErrors.city;
          return newErrors;
        });
      }
    }
  }, [data.city, allCities]);

   return (
    (loading || leadGenerationLoading) ? ( <PageLoader />
    ) : (
      <div className="container">
        
        <div className="row justify-content-center mt-4">
          
          <div className="col-12 col-md-12 px-4">
          
            <div className="ht_plan_summery" id="hide">
              <div className="plan_header_box">
                <div className="nws_paper_title">
                  <div className="back-btn-pincode">
                    <FontAwesomeIcon icon={faArrowLeft} size="2x" className="faArrowLeft" onClick={redirectToHome} />
                  </div>
                  <div className="feature">
                    <span className="p_title">
                      {planNames[sessionStorage.getItem("stg_selectedPlan_Name")] || sessionStorage.getItem("stg_selectedPlan_Name")}
                    </span>
                    { data.gift_id ? (
                      <div className="year_title_main">
                        <SafeImage src={data.gift_image} alt={data.gift_name} className="" />
                        <span className="year_title withGift">
                          {`Get ${schemPublication} for ${sessionStorage.getItem("moe_acq_selected_yearPlan")} months at ₹${sessionStorage.getItem("moe_acq_selected_planPrice")} + free ${data.gift_name}`}
                        </span>
                      </div>
                    ):(
                      <span className="year_title">
                        {sessionStorage.getItem("moe_acq_selected_yearPlan") > 0 && sessionStorage.getItem("moe_acq_selected_yearPlan") + " Months Plan"}
                      </span>
                    )}
                  </div>
                </div>
                <div className="nws_paper_price_sec">
                  <span className="last_price">
                    <strike>
                      {sessionStorage.getItem("moe_acq_selected_coverPrice") > 0 && "₹"}
                      {sessionStorage.getItem("moe_acq_selected_coverPrice") > 0 && sessionStorage.getItem("moe_acq_selected_coverPrice")}
                    </strike>
                  </span>
                  <span className="orgnl_price">₹{sessionStorage.getItem("moe_acq_selected_planPrice")}</span>
                </div>

              </div>
            </div>
          </div>
        </div>

        <div className="row summery_plan_row">
          <div className="col-12 col-md-12 px-5">
            <div className="contact_plan_summery px-2">
              <div className="header_title">
                <img src={contactIcon} className="mr-3" />
                <span>Contact Information</span>
              </div>
              <div className="contact_header_box">
                <div className="cntct_title">
                  <form className="cntct_fields">
                    <div className="row">
                      <div className="col-12 col-md-6">
                        <div className="input-style">
                          <label htmlFor="mobile">
                            Mobile No <span>*</span>
                          </label>
                          <div className="d-flex">
                          <input
                            type="text"
                            className={`order-input ${otpValidated && data.mobile_no ? 'valid-tick' : ''}`}
                            name="mobile_no"
                            value={data.mobile_no || ""}
                            onChange={handleChange}
                            onBlur={checkMobileExistWithEvent}
                            placeholder="Enter Mobile No"
                            id="mobile"
                            autoComplete="off"
                            maxLength={10}
                            disabled={leadGenerationLoading} // Disable while loading
                            onInput={(e) => {
                              if (e.target.value.length > e.target.maxLength)
                                e.target.value = e.target.value.slice(
                                  0,
                                  e.target.maxLength
                                );
                            }}
                          />
                          {otpValidated && data.mobile_no && (
                            <span className="input-tick">✔</span>
                          )}
                          </div>
                          <span className="text-danger">{mobileError || formErrors.mobile_no}</span>
                        </div>
                      </div>
                      <div className="col-12 col-md-6">
                        <div className="input-style">
                          <label htmlFor="email">
                            Email Id <span>*</span>
                          </label>
                          <div className="d-flex">
                          <input
                            type="text"
                            id="email"
                            name="email"
                            className={`order-input ${otpValidatedEmail && data.email && forInstitutional ? 'valid-tick' : ''}`}
                            placeholder="Enter email"
                            value={data.email || ""}
                            readOnly={otpValidatedEmail && data.email && forInstitutional}
                            onChange={!otpValidatedEmail || !forInstitutional ? handleChange : undefined}
                            onBlur={!otpValidatedEmail || !forInstitutional ? saveEmailWithEvent : undefined}
                          />
                          {otpValidatedEmail && data.email && forInstitutional && (
                            <span className="input-tick">✔</span>
                          )}
                          </div>
                          <span className="text-danger">{formErrors.email}</span>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row summery_plan_row">
          <div className="col-md-12 px-5">
            <div className="address_plan_summery px-2">
              <div className="header_title">
                <img src={addressBook} className="mr-3" />
                <span>Shipping Address</span>
              </div>
              <div className="address_header_box">
                <div className="adres_title">
                  <form className="address_fields">
                  <div className="row">
                    <div className="col-12 col-md-6">
                      <div className="input-style">
                        <label htmlFor="fname">
                          Name <span>*</span>
                        </label>
                        <input
                          type="text"
                          id="fname"
                          name="first_name"
                          value={data.first_name || ""}
                          onChange={handleChange}
                          onBlur={saveName}
                          placeholder="Enter Name"                     
                        />
                        <span className="text-danger">
                          
                          {formErrors.first_name}
                        </span>
                      </div>
                    </div>
                    <div className="col-12 col-md-6">
                      <div className="input-style">
                        <label htmlFor="flat">
                          Flat/House No/Floor No.
                          <span>*</span>
                        </label>
                        <input
                          type="text"
                          id="flat"
                          name="flat"
                          value={data.flat || ""}
                          maxLength={9}
                          onChange={handleChange}
                          onBlur={saveFlatNo}
                          placeholder="Enter Flat/House No"
                        />
                        <span className="text-danger">{formErrors.flat}</span>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12 col-md-6">
                      <div className="input-style">
                        <label htmlFor="block">
                          Block/Street/Plot No.
                          <span>*</span>
                        </label>
                        <input
                          type="text"
                          id="block"
                          name="block"
                          maxLength={50}
                          value={data.block || ""}
                          onChange={handleChange}
                          onBlur={saveBlockStreet}
                          placeholder="Enter Block/Street No"
                        />
                        <span className="text-danger">{formErrors.block}</span>
                      </div>
                    </div>
                    <div className="col-12 col-md-6">
                      <div className="input-style">
                        <label htmlFor="locality">
                          Locality <span>*</span>
                        </label>
                        <input
                          type="text"
                          id="locality"
                          name="locality"
                          maxLength={50}
                          value={data.locality || ""}
                          onChange={handleChange}
                          onBlur={savelocality}
                          placeholder="Enter Locality"
                        />
                        <span className="text-danger">{formErrors.locality}</span>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12 col-md-6">
                        <div className="input-style city-dropdown-container">
                          <label htmlFor="city">
                            City <span>*</span>
                          </label>
                          {citiesLoading ? (
                            <div className="city-loading">
                              <input
                                type="text"
                                disabled
                                placeholder="Loading cities..."
                                className="order-input loading"
                              />
                              <div className="spinner-border spinner-border-sm" role="status">
                                <span className="sr-only">Loading...</span>
                              </div>
                            </div>
                          ) : (
                            <>
                              <input
                                type="text"
                                id="city"
                                name="city"
                                value={citySearchTerm}
                                onChange={handleChange}
                                onBlur={saveCityOnBlur}
                                onFocus={() => {
                                  // Clear city validation errors when user focuses on input
                                  setFormErrors(prevErrors => {
                                    const newErrors = { ...prevErrors };
                                    delete newErrors.city;
                                    return newErrors;
                                  });
                                  
                                  if (citySearchTerm.trim() !== '' || allCities.length > 0) {
                                    setShowCityDropdown(true);
                                  }
                                }}
                                placeholder="Search and select city"
                                className={`order-input ${isCityValid ? 'valid-city' : ''} ${formErrors.city ? 'error' : ''}`}
                                autoComplete="off"
                              />
                              {showCityDropdown && filteredCities.length > 0 && (
                                <div className="city-dropdown">
                                  {filteredCities.slice(0, 10).map((city, index) => (
                                    <div
                                      key={city.id}
                                      className="city-option"
                                      onMouseDown={(e) => {
                                        e.preventDefault(); // Prevent blur event
                                        setIsSelectingFromDropdown(true);
                                        selectCity(city);
                                        // Reset the flag after a short delay
                                        setTimeout(() => setIsSelectingFromDropdown(false), 200);
                                      }}
                                      onClick={(e) => {
                                        e.preventDefault();
                                      }}
                                    >
                                      <div className="city-main">{city.city}</div>
                                    </div>
                                  ))}
                                </div>
                              )}
                              {showCityDropdown && filteredCities.length === 0 && citySearchTerm.trim() !== '' && (
                                <div className="city-dropdown">
                                  <div className="city-no-results">
                                    No cities found. Please check your spelling.
                                  </div>
                                </div>
                              )}
                            </>
                          )}
                          <span className="text-danger">{formErrors.city}</span>
                        </div>
                      </div>
                      <div className="col-12 col-md-6">
                        <div className="input-style">
                          <label htmlFor="pincode">
                            Pincode <span>*</span>
                          </label>
                          <input
                            type="text"
                            id="pincode"
                            name="pincode"
                            maxLength={6}
                            value={data.pincode || ""}
                            onChange={handleChange}
                            onBlur={savePincode}
                            placeholder="Enter Pincode"
                            className="order-input"
                            onInput={(e) => {
                              if (e.target.value.length > e.target.maxLength)
                                e.target.value = e.target.value.slice(
                                  0,
                                  e.target.maxLength
                                );
                            }}
                          />
                          <span className="text-danger">{formErrors.pincode}</span>
                        </div>
                      </div>
                  </div>
                  <div className="terms mb-3 blackClourV2">
                      <input
                        type="checkbox"
                        name="terms"
                        id="terms"
                        value={isChecked}
                        checked={isChecked}
                        onChange={updateTermsCheckbox}
                      />
                      <label htmlFor="terms" className="terms-label ml-2">
                        <span>I agree to </span>
                        <a className="not-href" onClick={showTermsPopup}> Terms &amp; Conditions</a>
                      </label>
                      {termsErrmsg && (
                        <span className="text-danger">
                          {"Please agree terms & conditions"}
                        </span>
                      )}
                      
                    </div>
                    <div className="address_btn mt-1 mb-3 text-center">
                      {(!checkout ? (<button
                        className="btn checkout-btn"
                        value={data.terms}
                        onClick={handleSubmit}
                      >
                        CHECKOUT
                      </button>) : 
                      (<button
                        className="btn checkout-btn disabled" disabled
                      >
                        Please wait....
                      </button>)
                      
                    )}
                      {/* <button
                        className="btn checkout-btn"
                        value={data.terms}
                        onClick={handleSubmit}
                      >
                        CHECKOUT
                      </button> */}
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        {paytmPageShow && mId && transToken &&
          gateway &&
          (gateway === "Paytm" ? (
            <ShowPaytmPaymentPage txnToken={transToken} mIdToken={mId} />
          ) : (
            <ShowRazorPayPaymentPage
              txnToken={transToken}
              mobile={data.mobile_no}
              email={data.email}
              name={data.first_name}
              price={orderData?.planPrice ?? sessionStorage.getItem("moe_acq_selected_planPrice")}
              onDismissRazorpay={onDismissRazorpay}
              mIdToken={mId}
            />
          ))}
            <TermsPopup
            showModalPopup={showPopupAlertState}
            onPopupClose={closeTermsPopup}
          ></TermsPopup>
          <OTPValidation
              show={showOTPModal}
              handleClose={(success) => {
                  setShowOTPModal(false);
                  setOtpValidated(success);
              }}
              sendOtp={() => sendOtp(data.mobile)}
              validateOtp={validateOtp}
              createNewLead={createNewLead}
              otpSource={data.mobile_no}
              // otpSource={otpType ? data.email : data.mobile_no}
              // otpType={otpType}
          />
          <CorporateMailUpdatePopup show={showMailUpdateModal}
              handleClose={(success) => {
                  setShowMailUpdateModal(false);
                  // setOtpValidated(success);
              }}
              mobile={data.mobile_no}
              email={data.email}
              updateEmailAddress={updateEmailAddress}
              defultAlert={defultAlert}
              emailUpdated={emailUpdated}
              />
          {/* <CorporateDigitalPopup show={validDigitalOrder}
              handleClose={(success) => {
                  setValidDigitalOrder(false);
                  // setOtpValidated(success);
              }}
              mobile={data.mobile_no}
              email={data.email}
              /> */}
          <ToastContainer />
      </div>
    )
  );
}

export default Order;
